import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { GlobalStateProvider } from "./core/state/GlobalStore";
// import * as serviceWorker from "./serviceWorker";
//import "./whyDidYouRender";

if (module.hot) {
    module.hot.accept();
}

ReactDOM.render(
    <GlobalStateProvider>
        <App />
    </GlobalStateProvider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
